// Node.js polyfills for browser compatibility
import { Buffer } from 'buffer';

// Make Buffer available globally
window.Buffer = Buffer;

// Polyfill process if needed
if (typeof window.process === 'undefined') {
  (window as unknown as { process: object }).process = {
    env: {},
    version: 'v18.0.0',
    versions: { node: '18.0.0' },
    platform: 'browser',
    nextTick: (cb: () => void): Promise<void> => Promise.resolve().then(cb),
  };
}
